import {MoneyLabel} from "../../../../general/MoneyLabel.tsx";
import {PrimaryButton} from "../../../../general/PrimaryButton.tsx";
import {toDecimalFromMoney, type Money} from "../../../../../lib/Money.ts";

interface SelectionFooterProps {
    selectedCount: number;
    selectedTotal: Money;
    onBookToAccount: () => void;
}

export function SelectionFooter({selectedCount, selectedTotal, onBookToAccount}: SelectionFooterProps) {
    if (selectedCount === 0) return null;
    return (
        <div className="flex items-center justify-between border-t border-border bg-white py-3">
            <span className="text-sm text-foreground">
                {selectedCount} geselecteerd
                {" · "}
                <span className="font-medium">
                    <MoneyLabel
                        value={toDecimalFromMoney(selectedTotal)}
                        currency={selectedTotal.currency}
                        showCurrency={true}
                    />
                </span>
            </span>
            <PrimaryButton
                title={`Wijzig grootboekrekening (${selectedCount})`}
                onClick={onBookToAccount}
            />
        </div>
    );
}
